import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import Pagination from '../components/Pagination/Pagination';
import UserLogList from '../components/UserLogList/UserLogList';
import FilterActions from '../components/FilterActions/FilterActions';
import FilterLogs from '../components/FilterLogs/FilterLogs';
import Spinner from '../components/Spinner';
import { fetchUserLogs } from '../actions/logs';
import { addFilter, removeFilter, removeAllFilters } from '../actions/filters';
import { findUser } from '../actions/users';
import userPage from '../decorators/userPage';
import {
  getUserLogs,
  getPageCount,
  getFilters,
  getAllUsersWithoutPagination,
} from '../reducers';

class UserLogs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      usedFilters: null,
    };

    this.fetchLogs = this.fetchLogs.bind(this);
  }

  componentDidMount() {
    this.fetchLogs();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.userId !== this.props.userId) {
      this.fetchLogs();
    }

    if (oldProps.page !== this.props.page) {
      this.fetchLogs();
    }
  }

  fetchLogs(filters, forcePage) {
    const { usedFilters } = this.state;
    if (!filters) {
      if (usedFilters && Object.keys(usedFilters).length) {
        filters = usedFilters;
      } else {
        filters = {};
      }
    }

    const { fetchUserLogs, findUser, userId, users, page } = this.props;
    this.setState({ loading: true, usedFilters: filters });
    if (forcePage && forcePage.toString() !== page) {
      this.props.history.push(`/users/${userId}/logs?page=${forcePage}`);
      return;
    }
    fetchUserLogs(userId, filters, page)
      .then((logs) => {
        const actorIds = [];
        logs.forEach((log) => {
          if (!log.actor_id) {
            return;
          }
          const actorId = log.actor_id.toString().split(':')[1];
          if (
            actorId &&
            Number.isInteger(parseInt(actorId, 10)) &&
            !actorIds.includes(actorId)
          ) {
            actorIds.push(actorId);
          }
        });

        let needToLoadUsers = actorIds.filter(
          (actorId) => !users.find((u) => u.id.toString() === actorId),
        );
        needToLoadUsers.forEach((userId) => findUser(userId));
        this.setState({ loading: false });
      })
      .catch((e) => this.setState({ loading: false }));
  }

  render() {
    const { user, users, userId, logs, pageCount, page, filters } = this.props;
    const { loading } = this.state;

    if (!user || !logs) {
      return (
        <div style={{ minHeight: '50vh' }}>
          <Spinner showLoader={true} />
        </div>
      );
    }

    return (
      <div>
        <h1>Logs</h1>
        <FilterActions onSubmit={this.fetchLogs} loading={loading} />
        <FilterLogs logs={logs} filters={filters}>
          <UserLogList user={user} users={users} />
        </FilterLogs>
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => `/users/${userId}/logs?page=${pageNum}`}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { location: { search } }) => {
  const { page = 1 } = qs.parse(search, { ignoreQueryPrefix: true });

  return {
    filters: getFilters(state),
    logs: getUserLogs(state, page),
    users: getAllUsersWithoutPagination(state),
    pageCount: getPageCount(state, 'logs', `fetchByUser`, page),
    page,
  };
};

const mapDispatchToProps = {
  fetchUserLogs,
  addFilter,
  findUser,
  removeFilter,
  removeAllFilters,
};

export default compose(
  withRouter,
  userPage,
  connect(mapStateToProps, mapDispatchToProps),
)(UserLogs);
